export const SDK_VERSION = '8.36.0';
